import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';


// assign defaults for following if not provided in env
const oAuthConfig = {
  ...environment.oAuth,
  timeoutFactor: 0.25,
  sessionChecksEnabled: true,
  showDebugInformation: true,
  strictDiscoveryDocumentValidation: false,
  silentRefreshTimeout: 1000,
}

export const authConfig: AuthConfig = {
  issuer: oAuthConfig.issuer,
  clientId: oAuthConfig.clientId, // The "Auth Code + PKCE" client
  responseType: 'code',
  redirectUri: oAuthConfig.redirectUri,

  /*
  * When using Azure AD for OAuth:
  *
  * If the backend throws 401 Unauthorized, create an application scope in Azure portal and add that to the scope
  *
  * Azure AD uses a nonce in a specific way in its JWT header. This can break the standard JWT validation.
  * We need to include application specific scope to resolve that issue.
  *
  * Application specific scope can be defined in Azure portal under
  * Expose an API > Add a scope
  *
  * The following document may act as a good reference:
  * https://learn.microsoft.com/en-us/azure/active-directory/develop/quickstart-configure-app-expose-web-apis
  *
  * scope: 'openid api://<CLIENT_ID>/app'
  *
  */
  scope: 'openid', // Ask offline_access to support refresh token refreshes
  timeoutFactor: oAuthConfig.timeoutFactor, // For faster testing
  sessionChecksEnabled: oAuthConfig.sessionChecksEnabled,
  showDebugInformation: oAuthConfig.showDebugInformation, // Also requires enabling "Verbose" level in devtools
  clearHashAfterLogin: false, // https://github.com/manfredsteyer/angular-oauth2-oidc/issues/457#issuecomment-431807040,
  nonceStateSeparator : 'semicolon', // Real semicolon gets mangled by IdentityServer's URI encoding
  tokenEndpoint: oAuthConfig.tokenEndpoint,
  strictDiscoveryDocumentValidation: oAuthConfig.strictDiscoveryDocumentValidation,

  /*
  * When using Azure AD for OAuth:
  *
  * Remove disablePKCE: true when using Azure AD for OAuth
  *
  * Microsoft recommends using PKCE and OIDC with auth code flow. The following document may act as a good reference:
  * https://learn.microsoft.com/en-us/azure/active-directory/develop/v2-oauth2-auth-code-flow
  */
  disablePKCE: true,
  silentRefreshShowIFrame: false,
  silentRefreshTimeout: oAuthConfig.silentRefreshTimeout
};
